import React, { Component } from 'react';
import { Control, Errors } from 'react-redux-form';
import classnames from 'classnames';

class FileUpload extends Component {
    render() {
        let formRowClassNames = classnames({
            form__row: true,
            'form__row--error': !this.props.valid && this.props.touched,
            'form__row--disabled': this.props.disabled
        });

        return (
            <div className={formRowClassNames}>
                <label className="form__label">
                    <span className="form__title">
                        {this.props.title}
                        {this.props.isRequired ? (
                            <span className="form__required">*</span>
                        ) : (
                            ''
                        )}
                    </span>
                    <div className="form__row-upload">
                        <Control.file
                            model={this.props.model}
                            className="form__file-input"
                            onChange={this.props.onChange}
                            disabled={this.props.disabled}
                            validators={this.props.validators}
                        />
                    </div>
                </label>
                <Errors
                    wrapper={props => (
                        <div className="form__error-messages">
                            {props.children}
                        </div>
                    )}
                    className="errors"
                    model={this.props.model}
                    show="touched"
                    messages={this.props.messages}
                />
            </div>
        );
    }
}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/ui/file-upload.js